import ApplyProfilesScreen from './apply-profiles.screen';

export default ApplyProfilesScreen;
